import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CheckCheckIcon } from "lucide-react";

export const ThankYouNotification = ({
  responseId,
}: {
  responseId: string;
}) => {
  return (
    <Alert>
      <CheckCheckIcon className="h-5 w-5" />
      <AlertTitle>
        Thank you for sharing your results with the community!
      </AlertTitle>
      <AlertDescription className="text-sm">
        Your response ID is <code>{responseId}</code>
      </AlertDescription>
    </Alert>
  );
};
